import React from 'react';

function Contact({contact, onClick}) {
  return (
    <button
      key={contact.id}
      type="button"
      className="member"
      style={{ textAlign: 'left' }}
      onClick={onClick}
    >
      <div
        className="member__img"
        data-letter={contact.LAST_NAME[0].toUpperCase()}
      ></div>
      <div className="member__inner">
        <p className="member__name">
          {contact.LAST_NAME}&nbsp;
          {contact.FIRST_NAME !== ' ' ? `${contact.FIRST_NAME[0].toUpperCase()}.` : null}
          &nbsp;
          {contact.MIDDLE_NAME ? `${contact.MIDDLE_NAME[0].toUpperCase()}.` : null}
        </p>
        <p className="member__post">{contact.JOB_TITLE}</p>
      </div>
    </button>
  );
}

export default Contact;
